import Api from './Api';

const getAllPartners = () => {
  return Api().get('/partners/');
};
const deletePartner = (id) => {
  return Api().delete(`/partners/${id}`);
};
const putPartners = (data, id) => {
  return Api().put(`/partners/${id}`, data, {
    headers: {
      'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
    },
  });
};

const postPartners = (data) => {
  return Api().post(`/partners/`, data, {
    headers: {
      'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
    },
  });
};

const getPartnersIndividual = (_id) => {
  return Api().get(`partners/${_id}`);
};

const getPartners = () => {
  return Api().get(`/partners/`);
};
export {
  putPartners,
  postPartners,
  getPartnersIndividual,
  getPartners,
  deletePartner,
  getAllPartners,
};
